getUserProfilesAction